module.exports = __webpack_public_path__ + "static/mw1-d6ba5803fa23ee3511e0ebc4e38f4f7e.jpg";